import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { CopyOutlined, DeleteOutlined, RightOutlined, ScanOutlined } from "@ant-design/icons";
import { App, Layout, Spin } from "antd";
import { observer } from "mobx-react";
import { Fragment, useEffect, useState } from "react";
import { AnalyseResult } from "./analyseResult.js";
import { ProFooter, ProTag } from "./proFooter.js";
import { ThumbnailsList } from "./thumbnailsList.js";
import { useStores } from "../store/stores.js";
import { __, _n } from "../utils/i18n.js";
const { Header, Content, Footer } = Layout;
const SingleFileContent = observer(()=>{
    const { message } = App.useApp();
    const { attachmentsStore, optionStore } = useStores();
    const [forceNewSchema, setForceNewSchema] = useState(false);
    const { others: { isPro, showProHints } } = optionStore;
    const { single, singleBusy } = attachmentsStore;
    useEffect(()=>{
        setForceNewSchema(false);
    }, [
        single
    ]);
    return /*#__PURE__*/ _jsxs(Layout, {
        children: [
            /*#__PURE__*/ _jsxs(Header, {
                style: {
                    background: "#fff"
                },
                children: [
                    __("Thumbnails"),
                    " ",
                    /*#__PURE__*/ _jsx(RightOutlined, {}),
                    " ",
                    __("Single file")
                ]
            }),
            /*#__PURE__*/ _jsx(Content, {
                style: {
                    margin: "24px 16px 0"
                },
                children: /*#__PURE__*/ _jsx("div", {
                    style: {
                        padding: 24,
                        background: "#fff",
                        minHeight: 360
                    },
                    className: "rtg-single",
                    children: /*#__PURE__*/ _jsx(Spin, {
                        spinning: !!(singleBusy || single?.busy),
                        children: single ? /*#__PURE__*/ _jsxs("div", {
                            children: [
                                /*#__PURE__*/ _jsx("h3", {
                                    children: single.filename
                                }),
                                /*#__PURE__*/ _jsx("div", {
                                    className: "clear"
                                }),
                                !!single.medium && /*#__PURE__*/ _jsxs("div", {
                                    className: "rtg-size-img",
                                    children: [
                                        /*#__PURE__*/ _jsx("div", {
                                            children: "medium"
                                        }),
                                        /*#__PURE__*/ _jsx("img", {
                                            src: single.medium
                                        })
                                    ]
                                }),
                                !!single.thumbnail && /*#__PURE__*/ _jsxs("div", {
                                    className: "rtg-size-img",
                                    children: [
                                        /*#__PURE__*/ _jsx("div", {
                                            children: "thumbnail"
                                        }),
                                        /*#__PURE__*/ _jsx("img", {
                                            src: single.thumbnail
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsx("div", {
                                    className: "clear"
                                }),
                                /*#__PURE__*/ _jsx(AnalyseResult, {
                                    legend: /*#__PURE__*/ _jsx(CopyOutlined, {}),
                                    style: {
                                        display: "inline-block",
                                        marginRight: 10
                                    },
                                    children: /*#__PURE__*/ _jsx("li", {
                                        children: _n("%d thumbnail", "%d thumbnails", single.cntGenerated, single.cntGenerated)
                                    })
                                }),
                                /*#__PURE__*/ _jsx(AnalyseResult, {
                                    legend: /*#__PURE__*/ _jsx(ScanOutlined, {}),
                                    style: {
                                        display: "inline-block",
                                        marginRight: 10
                                    },
                                    children: /*#__PURE__*/ _jsx("li", {
                                        children: _n("%d thumbnail needs to be generated", "%d thumbnails need to be generated", single.newThumbnailsCount, single.newThumbnailsCount)
                                    })
                                }),
                                /*#__PURE__*/ _jsx(AnalyseResult, {
                                    legend: /*#__PURE__*/ _jsx(DeleteOutlined, {}),
                                    style: {
                                        display: "inline-block",
                                        marginRight: 10
                                    },
                                    children: /*#__PURE__*/ _jsx("li", {
                                        children: __("%s unused", single.deletableSpaceFormat)
                                    })
                                }),
                                single.usedSchema !== single.newSchema && /*#__PURE__*/ _jsx("div", {
                                    className: "notice inline notice-info notice-alt",
                                    style: {
                                        margin: "0 0 10px"
                                    },
                                    children: /*#__PURE__*/ _jsxs("p", {
                                        children: [
                                            __('The thumbnails were created before the last change of the thumbnail folder and file name structure. When using the "Regenerate" function, the old structure is kept, so that the image can still be found in existing posts (new structure would result in new image URL).'),
                                            /*#__PURE__*/ _jsx("br", {}),
                                            /*#__PURE__*/ _jsxs("label", {
                                                children: [
                                                    /*#__PURE__*/ _jsx("input", {
                                                        type: "checkbox",
                                                        checked: forceNewSchema,
                                                        onChange: ()=>setForceNewSchema(!forceNewSchema)
                                                    }),
                                                    __("Force new thumbnail path and filename and delete old thumbnails")
                                                ]
                                            }),
                                            /*#__PURE__*/ _jsx("br", {}),
                                            __("New schema:"),
                                            " ",
                                            /*#__PURE__*/ _jsx("code", {
                                                children: single.newSchema
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ _jsxs("div", {
                                    style: {
                                        margin: "0 0 10px"
                                    },
                                    children: [
                                        /*#__PURE__*/ _jsx("button", {
                                            className: "button button-primary",
                                            onClick: async ()=>{
                                                await single.regenerate(forceNewSchema, true);
                                                message.success(__("Successfully regenerated image!"));
                                            },
                                            children: __("Regenerate")
                                        }),
                                        !!single.error && /*#__PURE__*/ _jsx("div", {
                                            className: "notice inline notice-error notice-alt",
                                            style: {
                                                margin: "0 0 10px"
                                            },
                                            children: single.error
                                        }),
                                        "\xa0",
                                        (showProHints || isPro) && single.deletableSpace > 0 && /*#__PURE__*/ _jsxs(Fragment, {
                                            children: [
                                                /*#__PURE__*/ _jsx("button", {
                                                    className: "button",
                                                    onClick: ()=>single.clear(true),
                                                    disabled: !isPro,
                                                    children: __("Delete thumbnails of sizes that no longer exist")
                                                }),
                                                " ",
                                                /*#__PURE__*/ _jsx(ProTag, {
                                                    feature: "delete-unused-single"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsx(ThumbnailsList, {})
                            ]
                        }) : /*#__PURE__*/ _jsxs("div", {
                            children: [
                                /*#__PURE__*/ _jsx("h3", {
                                    children: __("No file selected.")
                                }),
                                /*#__PURE__*/ _jsx("p", {
                                    children: __("Please select an upload in the Analyze or bulk regenerate tab or open an upload in the media library to see details about the selected image.")
                                })
                            ]
                        })
                    })
                })
            }),
            !isPro && showProHints && /*#__PURE__*/ _jsx(Footer, {
                children: /*#__PURE__*/ _jsx(ProFooter, {})
            })
        ]
    });
});
export { SingleFileContent };
